// Schaltjahr berechnen
export function isLeapYear( a_year )
{
	return ( ( ( a_year % 4 === 0 ) && ( a_year % 100 !== 0 ) ) || ( a_year % 400 === 0 ) );
}

// Anzahl an Tage im Monat
export function getDaysInMonth( a_year, a_month )
{
	return [ 31, ( isLeapYear( a_year ) ? 29 : 28 ), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31 ][ a_month ];
}

export function setMonth( a_date, a_month )
{
	const date = new Date( a_date ),
		dayInMonth = a_date.getDate();
	
	date.setDate( 1 );
	date.setMonth( parseInt( a_month ) );
	
	const newDayInMonth = getDaysInMonth( date.getFullYear(), date.getMonth() );
	if ( dayInMonth >= newDayInMonth )
	{
		date.setDate( Math.min( dayInMonth, newDayInMonth ) );
	}
	else
	{
		date.setDate( dayInMonth );
	}
	return date;
}

export function setFullYear( a_date, a_year )
{
	const date = new Date( a_date ),
		dayInMonth = a_date.getDate();
	
	date.setDate( 1 );
	date.setFullYear( parseInt( a_year ) );
	
	const newDayInMonth = getDaysInMonth( date.getFullYear(), date.getMonth() );
	if ( dayInMonth >= newDayInMonth )
	{
		date.setDate( Math.min( dayInMonth, newDayInMonth ) );
	}
	else
	{
		date.setDate( dayInMonth );
	}
	return date;
}